module.exports = __webpack_public_path__ + "static/media/Valk3.c91b874a.png";